import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Identifica',
    desc: 'Localiza en qué etapa de desarrollo está tu hijo hoy.'
  }, {
    num: '02',
    title: 'Traduce',
    desc: "Usa el manual para entender el 'porqué' biológico de su conducta."
  }, {
    num: '03',
    title: 'Conecta',
    desc: 'Aplica el guión de respuesta y la técnica del Espejo para restaurar la armonía.'
  }];
  return <section className="py-24 bg-white" data-id="element-67">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-68">
        <FadeIn data-id="element-69">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brown mb-16" data-id="element-70">
            ¿Cómo funciona?
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-71">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-px bg-cream-dark z-0" data-id="element-72"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10 text-center" data-id="element-73">
              <div className="w-24 h-24 mx-auto bg-cream rounded-full flex items-center justify-center mb-6 border-8 border-white shadow-sm" data-id="element-74">
                <span className="text-3xl font-serif font-bold text-terracotta" data-id="element-75">
                  {step.num}
                </span>
              </div>
              <h3 className="text-2xl font-bold text-brown mb-4 font-serif" data-id="element-76">
                {step.title}
              </h3>
              <p className="text-brown-light leading-relaxed px-4" data-id="element-77">
                {step.desc}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}